import React, { createContext, FC, ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Loader from '../components/Loader';

import { selectIsLoading, setLoad } from '@/store/slices/loaderSlice';

export interface LoaderType {
  load: boolean;
  setLoad: Function;
}

export const LoaderContext = createContext<LoaderType>({
  load: false,
  setLoad: () => {},
});

export const LoaderProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const dispatch = useDispatch();
  const load = useSelector(selectIsLoading);

  return (
    <LoaderContext.Provider
      value={{
        load,
        setLoad: (value: boolean) => dispatch(setLoad(value)),
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const dispatch = useDispatch();
  const load = useSelector(selectIsLoading);

  return {
    load,
    setLoad: (value: boolean) => dispatch(setLoad(value)),
  };
};

export const GlobalLoader = () => {
  const load = useSelector(selectIsLoading);

  return <Loader show={load} />;
};
